module.exports = __webpack_public_path__ + "img/ico_home_title_right.b7865e6e.svg";